import PropTypes from 'prop-types'
import React from 'react'
import Lightbox from 'react-images'
import { connect } from 'react-redux'
import { getCurrentAd } from 'src/modules/ads/detail/selectors'
import { ImageManager } from 'src/core/imageManager'
import { getAdThumbnailUrl, getAdImageUrl } from 'SRC/modules/ads/shared/functions'
import { AdImagesBanners } from '../../Banners'

export class Images extends React.Component {
  constructor (props) {
    super(props)

    this.im = new ImageManager()

    this.state = {
      currentImage: 0,
      visibleImagesLength: this.getVisibleImagesLength(),
      leftEmpty: true,
      rightEmpty: true
    }
  }

	getVisibleImagesLength = () => this.props.ad ? this.props.ad.media.filter(item => item.visible).length : 0

	goToPrevious = () => {
	  this.setState(prevState => ({
	    ...prevState,
	    currentImage: this.state.currentImage === 0 ? this.state.visibleImagesLength - 1 : this.state.currentImage - 1
	  }))
	}

	goToNext = () => {
	  this.setState(prevState => ({
	    ...prevState,
	    currentImage: this.state.currentImage === this.state.visibleImagesLength - 1 ? 0 : this.state.currentImage + 1
	  }))
	}

	goToImage = (index) => {
	  this.setState(prevState => ({
	    ...prevState,
	    currentImage: index
	  }))
	}

	getVisibleImages = () => this.props.ad.media && Array.isArray(this.props.ad.media)
	  ? this.props.ad.media.filter(item => item.visible)
	  : []

	getLightBoxImages = () => {
	  const visibleImages = this.getVisibleImages()
	  return visibleImages.length
	    ? visibleImages.map(item => ({
	      src: getAdImageUrl(item),
	      thumbnail: getAdThumbnailUrl({ image: item })
	    }))
	    : null
	}

	getCustomControls = () => {
		const { ad } = this.props

	  return [
	    <AdImagesBanners key='ad-images-banners' currentImage={this.state.currentImage} />,
	    <div className='image-sides image-left' key='image-left' onClick={this.goToPrevious}>
	      <div className='arrow arrow-left'>
	        <div className='arrow_icon arrow-left_icon' />
	      </div>
	    </div>,
	    <div className='image-sides image-right' key='image-right' onClick={this.goToNext}>
	      <div className='arrow arrow-right'>
	        <div className='arrow_icon arrow-right_icon' />
	      </div>
	    </div>,
	    <div className='lightbox-custom-header' key='lightbox-custom-header'>
	      <span>{`${this.state.currentImage + 1}/${this.state.visibleImagesLength}`}</span>
	      <span>{ad && ad.titleCompiled ? ad.titleCompiled : ''}</span>
	    </div>,
	    <span key='empty' />]
	}

	render () {
	  const lightboxImages = this.getLightBoxImages()
	  const customControls = this.getCustomControls()

	  const theme = {
	    arrow__size__medium: {
	      display: 'none'
	    }
	  }

	  return <Lightbox currentImage={this.state.currentImage}
	    images={lightboxImages}
	    isOpen
	    onClickNext={this.goToNext}
	    onClickPrev={this.goToPrevious}
	    onClose={this.props.onLightboxClosed}
	    onClickThumbnail={this.goToImage}
	    showThumbnails
	    backdropClosesModal
	    customControls={[customControls]}
	    showCloseButton={false}
	    theme={theme} />
	}
}

const mapStateToProps = state => {
  return {
    ad: getCurrentAd(state)
  }
}

Images.propTypes = {
  ad: PropTypes.object.isRequired,
  onLightboxClosed: PropTypes.func
}

export default connect(mapStateToProps)(Images)
